import { useTranslation } from "react-i18next";

import ContentFrame from "../ContentFrame";
import DeleteAccount from "./DeleteAccount";

const Account = () => {
    const { t } = useTranslation();

    return (
        <ContentFrame
            title={t("Security##account")}
            customStyles={{
                marginTop: "24px"
            }}
        >
            <DeleteAccount />
        </ContentFrame>
    );
};

export default Account;
